import { render } from "./ChooseHomeworkDeadlineModalForm.vue?vue&type=template&id=63461734"
import script from "./ChooseHomeworkDeadlineModalForm.vue?vue&type=script&lang=js"
export * from "./ChooseHomeworkDeadlineModalForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__